/* This file was generated automatically. Do not edit manually. */

import { createAvailabilityBlocksRepository as availabilityBlocks } from './availabilityBlocks';
import { createConfigurationsRepository as configurations } from './configurations';
import { createEnterprisesRepository as enterprises } from './enterprises';
import { createExchangeRatesRepository as exchangeRates } from './exchangeRates';
import { createPaymentCardsRepository as paymentCards } from './paymentCards';
import { createPaymentCurrencyRepository as paymentCurrency } from './paymentCurrency';
import { createProductsRepository as products } from './products';
import { createReservationGroupsRepository as reservationGroups } from './reservationGroups';
import { createReservationsRepository as reservations } from './reservations';
import { createResourceCategoriesRepository as resourceCategories } from './resourceCategories';
import { createRestrictionsRepository as restrictions } from './restrictions';
import { createServicesRepository as services } from './services';

export * from './types';

export const distributorApiBasePath = '/api/bookingEngine/v1';

export const distributorRestRepositoryFactories = {
    availabilityBlocks,
    configurations,
    enterprises,
    exchangeRates,
    paymentCards,
    paymentCurrency,
    products,
    reservationGroups,
    reservations,
    resourceCategories,
    restrictions,
    services,
};
